// extracted by mini-css-extract-plugin
module.exports = {"section":"Expand_section__0oiLC","content":"Expand_content__847fD","showDesktop":"Expand_showDesktop__ZEfXv","expanded":"Expand_expanded__8at9Q"};